import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

/** Centred page column with a safe-area-aware gutter on small screens. */
export function Container({
  children,
  className,
  size = 'default',
}: {
  children: ReactNode
  className?: string
  size?: 'default' | 'narrow' | 'wide'
}) {
  const width = {
    narrow: 'max-w-3xl',
    default: 'max-w-6xl',
    wide: 'max-w-7xl',
  }[size]

  return <div className={cn('gutter mx-auto w-full', width, className)}>{children}</div>
}
